// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/9af90537/" + chunkId + "." + __webpack_require__.h() + ".v9af90537.js";
};